var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_368_1748",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_368_1748",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACA0lEQVR4nO2cQU7DMBBFswIuOOuu7J2vQXseFlEuVOAWgywFqQKEoLHH88f/Sd6wen5K3USksyyEEEIIIYQQQggh5BullMeU0iWl9LavS/0bSqqC4C8iDymll5yzflnb6XR6WpwD4f+LpD9ZVP8/SPqRRfX/h6QOl0X1v0NSPcWG8K/fxDnn9Q5J3dc68tscxr/e9hyQ1JGxG0T+XOfusvUes4GoWh8jB46Ln9Y7Umi1it04cl3X3s5L/dg0FNbex0jD4+J2Pffy7S2+9oiN5Gr1UdTWxwiCI/xGxLFbmA2JQ6cmeNqYOHLpgocNigMHE0ZuVGaJPHLDMlvkERuXWSNbBpDZI1uEEEa2eQTOyI/Vveh09enUxwVg7C1MZMext3CRHcaOG9lR7PiRHcSeJ/LA2PNFHhB73siGsRnZIDYj38LQBgiPjhCRdfojRHh7F+pK1mmvbOEj+BSRNfyVLX4ix40t/iLHi+04soaJzX/OGsDXDQzgCzQG8JUwA/iSowF8bdcAD+/CiQOHrnjaoDhyaYrHjYlDp0N43pA4dgu3EQFwDPOz3wLk2mteh1qJd4oNNa9DgcdIQM3r2IAHo8DM61jBR/1AzOtYObwq0jizKP4QA/qi+EOMnIziDzFENYo/xFjgKP773Ui99Xvd1xnpZ78F3J8QQgghhBBCCCFkMeQDxDui8g7UqesAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c726553a025b2c4885b794ba33f4b769.svg";
export { ForwardRef as ReactComponent };